export default {
  development: {
    API_URL: 'http://localhost:8085/api',
  },
  production: {
    API_URL: '/api',
  },
}[process.env.NODE_ENV];
